import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, role, token } = useSelector((state) => state.auth);
  const isLoggedIn = Boolean(isAuthenticated || token);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/playground" replace />;
  }

  return children;
};

export default ProtectedRoute;
